/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMewsListAliases {
  ADD_SCORE_MEWS_CUSTOM_DYNAMIC_BUTTON = 'add-score-mews-custom-dynamic-button',
  CONTEXTUAL_BAR = 'contextual-bar',
  DECK_SCORE_MEWS = 'deck-score-mews',
  FETCH_SCORE_MEWS_LIST = 'fetch-score-mews-list',
  FILTERED_LIST_SCORE_MEWS = 'filtered-list-score-mews',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_SCORE_MEWS_LIST = 'layout-score-mews-list',
  LEGENDES_SCORE_MEWS = 'legendes-score-mews',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  SCORES_MEWS_CARD = 'scores-mews-card',
}
export { ScoreMewsListAliases };
